const cleanHtml = (html: string): string => {
  if (!html || typeof html !== 'string') {
    return '';
  }

  const parser = new DOMParser();
  const doc = parser.parseFromString(html, 'text/html');

  const tagsToRemove = [
    'meta',
    'script',
    'link',
    'style',
    'header',
    'nav',
    'aside',
    'footer',
    'svg',
    'img',
    'noscript',
  ];

  tagsToRemove.forEach(tag =>
    doc.querySelectorAll(tag).forEach(el => el.remove())
  );

  doc.querySelectorAll('*').forEach(el => {
    el.removeAttribute('class');
    el.removeAttribute('style');
  });

  const result = doc.documentElement.outerHTML.trim();

  return result
    .replace(/\n\s*\n+/g, '\n\n')
    .replace(/[ \t]{3,}/g, ' ')
    .replace(/[ \t]+$/gm, '')
    .trim();
};

const readHtmlPage = (): string => {
  let result = document.documentElement.outerHTML;

  const iframes = document.querySelectorAll('iframe');

  if (iframes.length > 0) {
    iframes.forEach((iframe, index) => {
      try {
        const docIframe =
          iframe.contentDocument || iframe.contentWindow?.document;

        if (docIframe && docIframe.body) {
          result += `\n\n== Segue abaixo os elementos encontrados no iframe${
            iframes.length > 1 ? ` ${index + 1}` : ''
          }: ==\n\n`;
          result += docIframe.body.innerHTML;
        }
      } catch (error) {
        result += `\n\n== Não foi possível ler o iframe ${
          iframes.length > 1 ? ` ${index + 1}` : ''
        } por restrição de acesso. ==\n\n`;
      }
    });
  }

  return cleanHtml(result);
};

export { cleanHtml, readHtmlPage };
